import { Facebook, Send, Youtube } from 'lucide-react';
import { Controller, useFormContext } from 'react-hook-form'

function SocialMedia() {
    const methods = useFormContext()
    const { control, formState, getValues } = methods
    const { errors } = formState;

    return (
        <div className="pb-4">
            <h6 className="mb-3">Social Media</h6>

            <div className="row align-items-center mb-4">
                <label className="col-sm-3 col-form-label" htmlFor="twitterid">
                    Facebook
                </label>
                <div className="col-sm-6">
                    <div className="input-group">
                        <button type="button" className="btn p-0 input-group-icon border-0">
                            <Facebook size={20} color='#aaa9a9' />
                        </button>
                        <Controller
                            name="facebookUrl"
                            control={control}
                            render={({ field }) => (
                                <input
                                    {...field}
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter your link"
                                />
                            )}
                        />
                    </div>
                    {errors.facebookUrl && <p className='errMsg'>{errors.facebookUrl.message}</p>}
                </div>
            </div>


            <div className="row align-items-center mb-4">
                <label className="col-sm-3 col-form-label" htmlFor="twitterid">
                    Twitter
                </label>
                <div className="col-sm-6">
                    <div className="input-group">
                        <button type="button" className="btn p-0 input-group-icon border-0">
                            <img src={require('../../../assets/images/icons/twitter.svg').default} alt="X" />
                        </button>
                        <Controller
                            name="twitter"
                            control={control}
                            render={({ field }) => (
                                <input
                                    {...field}
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter your link"
                                />
                            )}
                        />
                    </div>
                    {errors.twitter && <p className='errMsg'>{errors.twitter.message}</p>}
                </div>
            </div>


            <div className="row align-items-center mb-4">
                <label className="col-sm-3 col-form-label" htmlFor="twitterid">
                    Youtube
                </label>
                <div className="col-sm-6">
                    <div className="input-group">
                        <button type="button" className="btn p-0 input-group-icon border-0">
                            <Youtube size={20} color='#aaa9a9' />
                        </button>
                        <Controller
                            name="youtubeUrl"
                            control={control}
                            render={({ field }) => (
                                <input
                                    {...field}
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter your link"
                                />
                            )}
                        />
                    </div>
                    {errors.youtubeUrl && <p className='errMsg'>{errors.youtubeUrl.message}</p>}
                </div>
            </div>
            
            <div className="row align-items-center mb-4">
                <label className="col-sm-3 col-form-label" htmlFor="twitterid">
                    Telegram
                </label>
                <div className="col-sm-6">
                    <div className="input-group">
                        <button type="button" className="btn p-0 input-group-icon border-0">
                            <Send size={20} color='#aaa9a9' />
                        </button>
                        <Controller
                            name="telegramUrl"
                            control={control}
                            render={({ field }) => (
                                <input
                                    {...field}
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter your link"
                                />
                            )}
                        />
                    </div>
                    {errors.instagramUrl && <p className='errMsg'>{errors.instagramUrl.message}</p>}
                </div>
            </div>

            <div className="row align-items-center mb-4">
                <label className="col-sm-3 col-form-label" htmlFor="sitemaintenance">
                    Site Maintainance
                </label>
                <div className="col-sm-6">
                    <div className="form-check form-switch">
                        <Controller
                            name="isMaintenance"
                            control={control}
                            render={({ field }) => (
                                <input
                                    {...field}
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={field.value}
                                    role="switch"
                                    id="flexSwitchCheckDefault"
                                />
                            )}
                        />

                        <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
                            {getValues("isMaintenance") ? "In online" : "Under Maintainance"}
                        </label>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SocialMedia